'use strict'

import * as types from '../../mutation-types'

let stakes = []
try {
  const memoryStakes = JSON.parse(window.localStorage.getItem('lotto-stakes'))
  if (_.isObject(memoryStakes)) {
    stakes = memoryStakes
  }
} catch (e) {
  //
}

export default {
  state: {
    stakes: stakes
  },
  mutations: {
    [types.ADD_STAKE_NUMBER](state, payload) {
      state.stakes.push(payload)
    },
    [types.REMOVE_STAKE_NUMBER](state, payload) {
      // state.stakes = _.remove(state.stakes, (v) => {
      //   return v !== payload
      // })
      state.stakes = state.stakes.filter((v) => {
        return v !== payload
      })
    },
    [types.EMPTY_STAKES](state) {
      state.stakes = []
    }
  },
  actions: {
    addNumberToStake({ commit }, data) {
      Object.assign(data, {
        ref: data.number + new Date().getTime()
      })
      commit(types.ADD_STAKE_NUMBER, data)
    },
    removeNumberFromStake({ commit }, index) {
      commit(types.REMOVE_STAKE_NUMBER, index)
    },
    emptyStakes({ commit }) {
      commit(types.EMPTY_STAKES)
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/lotto/store/modules/betting/index.js